module.exports = __webpack_public_path__ + "media/icons/mailing-youtube-2fc8314c.png";